import { IntegrationIconProps } from './types';

const Atlassian = ({ dimension }: IntegrationIconProps) => (
  <svg
    width={dimension || 32}
    height={dimension || 32}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.1186 14.084C10.9735 13.8941 10.7399 13.7939 10.5025 13.8197C10.265 13.8455 10.0584 13.9936 9.95749 14.2102L4.07422 25.9814C3.96525 26.1995 3.9769 26.4585 4.10501 26.666C4.23312 26.8734 4.45943 26.9997 4.70312 26.9997H12.8953C13.1633 27.006 13.4099 26.8535 13.5242 26.6107C15.2913 22.9565 14.2203 17.4003 11.1186 14.084Z"
      fill="url(#paint0_linear_1334_1128)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.4339 3.37762C12.4515 7.96969 12.1073 13.7944 14.528 18.7062L18.4776 26.6108C18.5966 26.8492 18.8401 26.9998 19.1064 26.9998H27.2971C27.5408 26.9998 27.7671 26.8735 27.8952 26.6661C28.0233 26.4586 28.035 26.1996 27.926 25.9815C27.926 25.9815 16.9068 3.92489 16.6299 3.3732C16.5181 3.14406 16.2853 2.99906 16.0305 3C15.7757 3.00095 15.5439 3.14765 15.4339 3.37762Z"
      fill="#2684FF"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1334_1128"
        x1="14.3428"
        y1="15.9006"
        x2="6.09079"
        y2="24.7588"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0052CC" />
        <stop offset="0.923" stopColor="#2684FF" />
      </linearGradient>
    </defs>
  </svg>
);
export default Atlassian;
